export default "__VITE_ASSET__BFAPWdi1__"